import { AdaptedGroup } from "../models";

type GroupWithId = Partial<Pick<AdaptedGroup, "id">>;

export type EnrollmentsRequestRoute = "parent" | "subgroup";

export const shouldRequestEnrollments = (
  activeTab: number,
  group: GroupWithId | null | undefined,
  enrollments: unknown[] | null | undefined,
): boolean => activeTab === 1 && group?.id != null && enrollments?.length === 0;

export const getEnrollmentsRequestRoute = (
  activeTab: number,
  group: GroupWithId | null | undefined,
  enrollments: unknown[] | null | undefined,
  isParentGroup: boolean,
): EnrollmentsRequestRoute | null => {
  if (!shouldRequestEnrollments(activeTab, group, enrollments)) return null;
  return isParentGroup ? "parent" : "subgroup";
};
